import { exportTableToPdf } from '../../utils/exportTableToPdf';
import { listCellValue } from './listActions';

export async function exportListPdf({ rows, columns, title, projectName, filename }) {
    await exportTableToPdf({
        title,
        projectName,
        visibleColumns: columns,
        rows,
        getCellValue: listCellValue,
        filename,
    });
}
